import { Grid, IconButton, Popper } from '@material-ui/core';
import { Search as SearchIcon, PlayCircleOutline } from '@material-ui/icons';
import styled from 'styled-components';
import { useState } from 'react';
import Cookies from 'universal-cookie';
import { appCategories, defaultRecentAppIds } from './constant';

const RECENT_KEY = 'bkt_recent_apps';
const MAX_RECENT = 4;

const allApps = appCategories.flatMap((cat) => cat.apps);

function getUserKey() {
  try {
    const cookies = new Cookies();
    const user = cookies.get('user_store');
    const uid = user?.id || user?.user_id;
    if (uid) return `${RECENT_KEY}_${uid}`;
  } catch {}
  return RECENT_KEY;
}

function getRecentApps() {
  try {
    const stored = JSON.parse(localStorage.getItem(getUserKey()));
    if (Array.isArray(stored) && stored.length > 0) {
      return stored.map((id) => allApps.find((a) => a.id === id)).filter(Boolean);
    }
  } catch {}
  return defaultRecentAppIds
    .map((id) => allApps.find((a) => a.id === id))
    .filter(Boolean);
}

function saveRecentApp(id) {
  try {
    const key = getUserKey();
    const current =
      JSON.parse(localStorage.getItem(key)) || defaultRecentAppIds.slice();
    const filtered = current.filter((i) => i !== id);
    localStorage.setItem(
      key,
      JSON.stringify([id, ...filtered].slice(0, MAX_RECENT))
    );
  } catch {}
}

function checkLoggedIn() {
  const cookies = new Cookies();
  return !!(cookies.get('access_token') || localStorage.getItem('AccessToken'));
}

// --- Styled components ---

const StyledPopper = styled(Popper)`
  z-index: 10000;
  width: 420px;
  max-width: calc(100vw - 16px);
  border-radius: 20px;
  background: #ebeef6;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  overflow: hidden;
`;

const Container = styled.div`
  height: 520px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  border-radius: 20px;
  box-shadow: inset 0 0 0 8px #ebeef6;
  padding: 8px;
  padding-right: 0;

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #cacdd3;
    border-radius: 3px;
  }
`;

const Content = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 12px 12px 8px;
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0f2f5;
  border-radius: 10px;
  padding: 7px 12px;
  margin-bottom: 12px;
`;

const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: #333;
  width: 100%;

  &::placeholder {
    color: #aaa;
  }
`;

const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin: 10px 0 6px;
  padding-left: 2px;

  i {
    font-size: 11px;
    color: #888;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #f0f2f5;
  margin: 8px 0;
`;

const AppBtn = styled(IconButton)`
  width: 100%;
  height: auto;
  min-height: 88px;
  border-radius: 10px !important;
  padding: 6px 4px !important;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;

  .MuiIconButton-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  &:hover {
    background: #f0f4ff !important;
  }
`;

const AppIcon = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const IconPlaceholder = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
`;

const VideoBadge = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 14px !important;
    color: #fff;
  }
`;

const AppName = styled.span`
  font-size: 11.5px;
  font-weight: 500;
  color: #183459;
  text-align: center;
  width: 100%;
  line-height: 1.3;
`;

// --- Video Modal ---

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBox = styled.div`
  background: #000;
  border-radius: 14px;
  overflow: hidden;
  width: 90vw;
  max-width: 820px;
  position: relative;
`;

const ModalClose = styled.button`
  position: absolute;
  top: 10px;
  right: 14px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: #fff;
  font-size: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const EmptyVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  background: #111;
`;

function VideoModal({ app, onClose }) {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()}>
        <ModalClose onClick={onClose}>✕</ModalClose>
        {app.videoUrl ? (
          <video
            src={app.videoUrl}
            controls
            autoPlay
            style={{ width: '100%', aspectRatio: '16/9', display: 'block' }}
          />
        ) : (
          <EmptyVideo>Video đang cập nhật...</EmptyVideo>
        )}
      </ModalBox>
    </ModalOverlay>
  );
}

// --- App Item ---

function AppItem({ app, onClick }) {
  return (
    <AppBtn onClick={onClick} title={app.title}>
      <AppIcon>
        {app.img ? (
          <img src={app.img} alt={app.title} />
        ) : (
          <IconPlaceholder>{app.title.charAt(0)}</IconPlaceholder>
        )}
        {app.type === 'video' && (
          <VideoBadge>
            <PlayCircleOutline />
          </VideoBadge>
        )}
      </AppIcon>
      <AppName>{app.title}</AppName>
    </AppBtn>
  );
}

// --- Main Component ---

function AppsDropdown({ anchorEl }) {
  const [search, setSearch] = useState('');
  const [recentApps, setRecentApps] = useState(getRecentApps);
  const [activeVideo, setActiveVideo] = useState(null);

  const handleAppClick = (app) => {
    saveRecentApp(app.id);
    setRecentApps(getRecentApps());

    if (app.type === 'video') {
      setActiveVideo(app);
      return;
    }

    if (app.type === 'auth-link' && !checkLoggedIn()) {
      window.location.href = '/dang-nhap';
      return;
    }

    if (app.link) {
      window.open(app.link, '_blank', 'noopener noreferrer');
    }
  };

  const lowerSearch = search.toLowerCase();
  const filteredCategories = search
    ? appCategories
        .map((cat) => ({
          ...cat,
          apps: cat.apps.filter((app) =>
            app.title.toLowerCase().includes(lowerSearch)
          )
        }))
        .filter((cat) => cat.apps.length > 0)
    : appCategories;

  return (
    <div className="apps-dropdown">
      <StyledPopper
        open
        anchorEl={anchorEl}
        placement="bottom"
        onClick={(e) => e.stopPropagation()}>
        <Container>
          <Content id="apps-dropdown-content">
            {/* Search bar */}
            <SearchWrapper>
              <SearchIcon style={{ color: '#aaa', fontSize: 18, flexShrink: 0 }} />
              <SearchInput
                placeholder="Tìm kiếm ứng dụng"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </SearchWrapper>

            {/* Recent section */}
            {!search && (
              <>
                <SectionLabel>Gần đây</SectionLabel>
                <Grid container spacing={1}>
                  {recentApps.map((app) => (
                    <Grid item xs={3} key={`recent-${app.id}`}>
                      <AppItem app={app} onClick={() => handleAppClick(app)} />
                    </Grid>
                  ))}
                </Grid>
                <Divider />
              </>
            )}

            {/* Categories */}
            {filteredCategories.map((cat, index) => (
              <div key={cat.id}>
                <SectionLabel>
                  <i className={cat.iconClass} />
                  <span>{cat.label}</span>
                </SectionLabel>
                <Grid container spacing={1}>
                  {cat.apps.map((app) => (
                    <Grid item xs={3} key={app.id}>
                      <AppItem app={app} onClick={() => handleAppClick(app)} />
                    </Grid>
                  ))}
                </Grid>
                {index < filteredCategories.length - 1 && <Divider />}
              </div>
            ))}
          </Content>
        </Container>
      </StyledPopper>

      {activeVideo && (
        <VideoModal app={activeVideo} onClose={() => setActiveVideo(null)} />
      )}
    </div>
  );
}

export default AppsDropdown;
